 import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Container, Button, Form } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const VentasPorAgencia = () => {
  const [periodos, setPeriodos] = useState([]);
  const [periodosSeleccionados, setPeriodosSeleccionados] = useState([]);
  const [cantidadGrupos, setCantidadGrupos] = useState(4);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState('0');
  const [datos, setDatos] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);

  useEffect(() => {
    axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/estadisticas/periodos-cargados')
      .then((res) => setPeriodos(res.data.periodos))
      .catch((err) => console.error('Error al cargar periodos:', err));
  }, []);

  const handlePeriodoChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, option => option.value);
    setPeriodosSeleccionados(selected);
  };

  const handleCantidadGruposChange = (e) => {
    const value = parseInt(e.target.value);
    setCantidadGrupos(value);
  };

  const handleGrupoChange = (e) => {
    const index = parseInt(e.target.value);
    setGrupoSeleccionado(e.target.value);
    if (grupos[index]) {
      setDatosFiltrados(grupos[index]);
    }
  };

  const fetchDatos = () => {
    if (periodosSeleccionados.length === 0) return;

    setLoading(true);
    axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/estadisticas/ventas-por-agencia', {
      params: { periodos: periodosSeleccionados }
    })
      .then((res) => {
        const datosOrdenados = res.data.detalle
          .sort((a, b) => b.promedio - a.promedio)
          .map((item, index) => ({
            id: index + 1,
            agencia: item.agencia,
            total: item.total,
            promedio: item.promedio
          }));

        const total = datosOrdenados.length;
        const tamañoGrupo = Math.ceil(total / cantidadGrupos);
        const nuevosGrupos = Array.from({ length: cantidadGrupos }, (_, i) =>
          datosOrdenados.slice(i * tamañoGrupo, (i + 1) * tamañoGrupo)
        );

        setDatos(datosOrdenados);
        setGrupos(nuevosGrupos);
        setGrupoSeleccionado('0');
        setDatosFiltrados(nuevosGrupos[0]);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error al cargar ventas por agencia:', err);
        setLoading(false);
      });
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(datosFiltrados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'VentasPorAgencia');
    XLSX.writeFile(wb, 'ventas_por_agencia.xlsx');
  };

  const columns = [
    { field: 'agencia', headerName: 'Agencia', width: 120 },
    {
      field: 'total',
      headerName: 'Total Recaudado',
      width: 180,
      type: 'number',
      valueFormatter: ({ value }) =>
        value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })
    },
    {
      field: 'promedio',
      headerName: 'Promedio por Período',
      width: 180,
      type: 'number',
      valueFormatter: ({ value }) =>
        value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })
    }
  ];

  return (
    <Container style={{ height:'100%', width: '100%' }}>
      <h2 className="text-center mt-3">Ventas por Agencia</h2>

      <Form.Group controlId="periodosSelect">
        <Form.Label>Seleccionar Períodos</Form.Label>
        <Form.Control as="select" multiple onChange={handlePeriodoChange}>
          {periodos.map((p) => (
            <option key={p} value={p}>{p}</option>
          ))}
        </Form.Control>
      </Form.Group>

      <Form.Group controlId="cantidadGruposSelect" className="mt-3">
        <Form.Label>Cantidad de Grupos</Form.Label>
        <Form.Select value={cantidadGrupos} onChange={handleCantidadGruposChange}>
          {[1, 2, 3, 4].map(n => (
            <option key={n} value={n}>{n}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <div className="d-flex gap-2 mt-3 mb-3">
        <Button onClick={fetchDatos} variant="primary">Consultar</Button>
        <Button onClick={exportToExcel} variant="success" disabled={datosFiltrados.length === 0}>
          Exportar a Excel
        </Button>
      </div>

      {grupos.length > 0 && (
        <Form.Group controlId="grupoSelect" className="mb-3">
          <Form.Label>Ver Grupo</Form.Label>
          <Form.Select value={grupoSeleccionado} onChange={handleGrupoChange}>
            {grupos.map((_, i) => (
              <option key={i} value={i}>Grupo {i + 1}</option>
            ))}
          </Form.Select>
        </Form.Group>
      )}

      <div style={{ height: '100%', width: '100%' }}>
        <DataGrid
          rows={datosFiltrados}
          columns={columns}
          loading={loading}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 20, 50]}
          pagination
        />
      </div>
    </Container>
  );
};

export default VentasPorAgencia;